import FSvg from './FSvg.vue'

export default FSvg
